<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-md-11 router-view-background">
    <div class="col-md-12">
      <the-filters 
        ref="filters"
        :filters="computedFilters"
        :showCleareble="showRedefine"
        @get-model="getFiltersModel"
        @on-cleareble="resetService"
        @search="searchItems"
      />
      <the-table 
        id="milk-closure"
        :dataItems="computedResults"
        :headers="headersForTable"
      >
      <template v-slot:status="{item}">
          <!-- <span class="d-block">{{item.status}}</span> -->
          <div style="display:flex; justify-content:center;">
          <small class="status_info" :style="`color: white; padding: 5px 10px; border-radius: 10px; background-color:${returnColorForStatus(item.status)}`">{{item.status}}</small>
          </div>
        </template>
        
        <template v-slot:countAnimals="">
          <span class="d-flex justify-content-center">Animais</span>
        </template>
        <template v-slot:count_animals="{item}">
          <a 
            class="text-link" 
            style="color:var(--medium-blue) !important"
            @click="openAnimalsModal(item)"
          >{{item.count_animals}}</a>
        </template>

        <template v-slot:actions="{item}">
          <v-btn 
            @click="redirectToDetails(item)"
            small
            outlined
            color="primary"
          ><i class="mdi mdi-eye-outline pr-1"></i>Visualizar</v-btn>
        </template>
      </the-table>

      <div class="col-md-12 d-flex justify-content-end">
        <v-pagination
          v-if="computedPagination ? computedPagination.total_pages > 1 : 0"
          v-model="page"
          :length="computedPagination ? computedPagination.total_pages : 0"
          color="var(--medium-blue)"
        ></v-pagination>
      </div>
    </div>

    <modal-service-animals 
      :service="dataForAnimalsModal"
      :isOpen="openModalAnimals"
      @close="openModalAnimals = false"
    />
  </div>
</template>

<script>
import TheTable from "@/components/layout/TheTable";
import TheFilters from "@/components/layout/TheFilters";
import {mapState, mapActions, mapMutations} from "vuex";
export default {
  name:"ClosuresList",
  components: {
    TheTable,
    TheFilters,
    ModalServiceAnimals: () => import("@/components/adm/services/ModalServiceAnimals.vue"),
  },
  data() {
    return {
      headersForTable:[
        {text:"Código Serviço", value:"code", sortable:true, type:"number"},
        {text:"Status", value:"status", has_slot:true, sortable:true},
        {text:"Controlador", value:"partner", sortable:true},
        {text:"Criador", value:"person", sortable:true},
        {text:"Data Emissão", value:"date_emission", sortable:true},
        {text:"Data Confirmação", value:"date_close", sortable:true},
        {text:"Animais Encerrados", value:"count_animals", has_slot:true, sortable:true, type:"number"},
        {text:"Ações", value:"actions", has_slot:true}
      ],
      showRedefine:false,
      query:{},
      page:1,
      openModalAnimals:false,
      dataForAnimalsModal:{}
    }
  },
  computed: {
    ...mapState("partners", ["partners"]),
    ...mapState("farms", ["farms"]),
    ...mapState("login", ["user"]),
    ...mapState("closures", ["closures", "pagination"]),
    ...mapState("animals", ["closure_reasons"]),
    computedResults() {
      const closures = Array.isArray(this.closures) ? this.closures : [];
      const services = closures.map(e => ({
        ...e,
        code:e.code,
        person:e.person?.name || "-",
        partner:e.partner?.name || "-",
        date_emission:e.date_emission,
        date_close:typeof e.date_close === "string" && e.date_close.trim().length > 0 ? e.date_close : e.status,
        count_animals:(Array.isArray(e.service_animals) ? e.service_animals : []).filter(e => e.kind_explanation && e.kind_explanation !== "").length
      }));
      const sameService = services.filter((f => e => !f.has(e.code) && f.add(e.code)) (new Set));
      return sameService;
    },
    computedPagination() {
      if(this.pagination) {
        return this.pagination;
      } 
      else {
        return false;
      }
    },
    //Essa computed devolve os filtros do componente
    computedFilters() {
      let result = [
        {name:"code", type:"text", label:"Código Serviço"},
        {name:"partner", type:"select", label:"Controlador", items:this.partners},
        {name:"farm", type:"select", label:"Fazenda", items:this.farms},
        {name:"date", type:"date", label:"Data"}
      ];
      if(this.user.attributes.kind === 'partner') {
        result.splice(1, 1);
      }
      return result;
    },
  },
  methods: {
    ...mapActions("partners", ["actionGetPartners"]),
    ...mapActions("farms", ["actionGetFarmsPartner"]),
    ...mapActions("closures", ["actionGetClosures"]),
    ...mapActions("animals", [ "actionGetAnimalsReasons"]),
    ...mapMutations("farms", ["SET_FARMS"]),
    redirectToDetails(item) {
      this.$router.push({name:"Services-details", params:{id:item.id}})
    },
    //Esse metodo vai abrir o modal de animais do serviço
    openAnimalsModal(service) {
      const serviceAnimals = Array.isArray(service.service_animals) ? service.service_animals : [];
      const closureReasons = Array.isArray(this.closure_reasons) ? this.closure_reasons : [];
      this.dataForAnimalsModal = {code:service.code, animals:serviceAnimals.filter(e => e.kind_explanation && e.kind_explanation !== "").map(e => ({
      ...e.animal,
      date_explanation:e.date_explanation,
      kind_closure:closureReasons.find(a => a.id === parseFloat(e.kind_explanation))?.name || "Não identificado",
      regime:e.regime
      }))};
      this.openModalAnimals = true;
    },
    openAnimalsModalIncorrect(service) {
      this.dataForAnimalsModal = {code:service.code, animals:service.incorret_animals.map(e => ({...e.animal, regime:e.regime}))};
      this.openModalAnimals = true;
    },
    async getFiltersModel(data) {
      this.query[data.title] = data.value;
      if(data.title === "partner") {
        delete this.query.farm;
        this.SET_FARMS([]);
        if(this.$refs.filters) this.$delete(this.$refs.filters.query, "farm");
        if(data.value) await this.actionGetFarmsPartner(data.value);
      }
    },
    async loadClosures(page = this.page) {
      await this.actionGetClosures({...this.query, page});
    },
    //Esse metodo é especifico para resetar os item iniciais de serviço
    async resetService() {
      this.query = {};
      this.showRedefine = false;
      if(this.page === 1) {
        await this.loadClosures(1);
      } else {
        this.page = 1;
      }
    },
    //Essa função faz o get dos items da tabela conforme os filtros
    async searchItems() {
      const {code, farm, partner, date} = this.query;
      if(code || farm || partner || date) {
        this.showRedefine = true;
        if(this.page === 1) {
          await this.loadClosures(1);
        } else {
          this.page = 1;
        }
      } else {
        this.$toast.warning("Informe ao menos um filtro de pesquisa !");
      }
    },
    
    //Esse metodo retorna a cor do status 
    returnColorForStatus(status) {
      if(status === "Em preenchimento") {
        return "#56707a" //dark grey
      }
      if(status === "Pendente") {
        return "#1f6fd1" // azul
      } 
      if(status === "Fechado") {
        return "#127a5c" // verde-azulado
      }      
      if(status === "Validado") {
        return "#2e7d32" // verde
      }
      if(status === "Classificado") {
        return "#9044eb" // purple (mesma cor da lista de Serviços)
      }
      else {
        return "#b45f06" // laranja - Finalizado
      }
    },
    //Esse metodo vai ler e retornar o id (criado pelo front) para passar para a api na busca
    returnStatusId(status) {
      if(status === "Pendente") {
        return "pending";
      }
      if(status === "Finalizado") {
        return "close"
      }
      if(status === "Em preenchimento") {
        return "open"
      }
      if(status === "Parcialmente Aprovado") {
        return "unaproved"
      }
      if(status === "Classificado") {
        return "classified"
      }
    },
  },
  async mounted() {
    await this.actionGetPartners();
    await this.actionGetAnimalsReasons();
    await this.loadClosures(1);
  },
  watch: {
    async page(val) {
      await this.loadClosures(val);
    }
  }
}
</script>
